import { isNative } from '../utils/platformUtils';

// Où le compte passe avant le paiement (spec v5 F3).
//
// Sur le web, un achat fait en invité s'attache à la session anonyme du
// navigateur : il ne suit ni le téléphone ni une autre fenêtre, et le web n'a
// pas de "Restore purchases" pour aller le rechercher (getCustomerInfo
// n'interroge que l'identité courante). Le natif garde l'ordre inverse, achat
// puis proposition de compte : le store sait retrouver un achat sur
// l'appareil, et interposer un compte avant la caisse y coûterait des ventes
// pour rien.
//
// Ici et pas dans un écran : la règle est née dans UnlockSheet (S6) et le
// dialogue d'achat de pack la contournait en appelant l'achat en direct
// (S9). Une règle de ce genre n'appartient à aucune surface, sinon la
// prochaine surface l'oubliera aussi.
//
// Elle vaut même quand les paiements sont simulés : c'est le geste d'achat
// qu'on protège, pas le backend, et c'est ce qui rend le parcours rejouable en
// local.
export function needsAccountBeforePurchase({ signedIn } = {}) {
  return !isNative() && !signedIn;
}

export default needsAccountBeforePurchase;

// Où "Restore purchases" a le droit d'exister (sécuriser les achats, lot 2).
//
// Natif seulement : sur le web, getCustomerInfo n'interroge que l'identité
// RevenueCat courante et ne retrouve rien, c'est le sync du miroir qui ramène
// l'achat une fois le compte connecté.
//
// Paiements réels seulement : sans canal RevenueCat il n'y a rien à restaurer.
//
// Les invités y ont droit, et c'est délibéré : celui qui a payé sans poser de
// compte et qui réinstalle n'a aucun autre chemin vers son achat, et Apple
// exige un mécanisme de restauration (guideline 3.1.1). Le danger, le transfert
// de l'achat vers une identité jetable par un projet RevenueCat réglé sur
// "Transfer to new App User ID", est traité à sa source : le boot ne déclenche
// plus de restore tout seul après une bascule d'identité. On ne le traite pas
// en cachant le bouton à celui qui en a le plus besoin.
//
// Ici et pas dans un écran, pour la même raison que la règle ci-dessus : la
// feuille de verrou et la page You portent chacune leur bouton Restore, et rien
// ne garantit qu'elles se souviendraient toutes les deux de la même règle.
export function canRestorePurchases({ realPayments } = {}) {
  return !!realPayments && isNative();
}
